import Button from '@material-ui/core/Button';

import styled from 'styled-components';

import { mediaQueries, fontFamily } from '../../libs';

export const ButtonStyled = styled(Button)`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: ${(props) => props.width} !important;
  height: ${(props) => props.height || '40px'} !important;
  border-radius: ${({ radius }) => radius} !important;
  border: ${({ border }) => border || 'none'} !important;
  color: ${({ textcolor }) => textcolor} !important;
  background-color: ${({ bgcolor, theme, disabled }) =>
    !disabled ? bgcolor || theme.colors.primary : '#C0C0C0'} !important;
  white-space: nowrap !important;
  outline: none !important;
  font-size: ${(props) => props.font || '13px'} !important;
  min-width: 30px !important;
  z-index: 2 !important;
  padding: 0 10px !important;
  margin: ${({ margin }) => margin || '0'} !important;
  line-height: 14px !important;

  .MuiButton-label {
    width: fit-content !important;
    height: fit-content !important;
    font-family: ${fontFamily} !important;
    font-weight: bold !important;
  }

  & span {
    max-width: 100% !important;
    height: 100% !important;
    white-space: normal !important;
  }

  &:hover {
    box-shadow: inset 0 -100px 0 rgba(0, 0, 0, 0.15) !important;
    transition: all 0.7s ease 0s !important;
  }

  &:active {
    box-shadow: unset !important;
    background: #c0c0c0 !important;
  }

  svg {
    margin: ${(props) => (props.name ? '0 6px 0 0' : 0)} !important;
    font-size: ${({ iconsize }) => iconsize || '20px'} !important;
    color: ${({ textcolor }) => textcolor} !important;
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    font-size: 13px !important;
  }
`;

export default {};
